module.exports = __webpack_public_path__ + "static/media/card.ba15a895.svg";